import { PropsWithChildren } from 'react';

import FormControl from '@mui/material/FormControl';
import InputLabel, { inputLabelClasses } from '@mui/material/InputLabel';
import { SxProps, Theme } from '@mui/material';

interface Props {
  id: string;
  name?: string;
  label: string;
  error?: string | boolean;
  extendedSx: SxProps;
  // value: string|number,
  //onChange: (SelectChangeEvent) => void
}

export const formControlSx = {
  width: '100%',
  borderRadius: '.5rem',
};

export const inputLabelSx = (theme: Theme) => ({
  color: 'var(--7D7D7D)',
  fontWeight: 300,
  fontSize: '1.4rem',
  paddingLeft: '10px',
  transform: 'translate(1.2rem, 2.2rem) scale(1)',

  [theme.breakpoints.up('sm')]: {
    // fontSize: '2rem',
    fontSize: '1.6rem', // 30.10
    transform: 'translate(1rem, 1.9rem) scale(1)',
  },

  [`&.${inputLabelClasses.shrink}`]: {
    display: 'none',
  },

  [theme.breakpoints.up('lg')]: {
    fontSize: '2rem',
    transform: 'translate(1.2rem, 1.6rem) scale(1)',
  },
});

const FormControlStyled = ({
  id,
  label,
  // area,
  children,
  error,
  extendedSx,
}: PropsWithChildren<Props>) => {
  return (
    <FormControl variant="standard" sx={{ ...formControlSx, ...extendedSx }} error={!!error}>
      {label ? (
        <InputLabel htmlFor={id} sx={inputLabelSx}>
          {label}
        </InputLabel>
      ) : null}
      {children}
      {/*<FormHelperText error={error} />*/}
    </FormControl>
  );
};

export default FormControlStyled;
